<template>
  <div>
    <NavHeader :activeIndex="'DownLoad'" />

    <div
      class="card-body p-lg-0 m-lg-0 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 ps-xl-40 pe-xl-40 letter-spacing welcome-lms-courses-box">
      <div class="row align-items-center text-center ">
        <div class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex align-items-center justify-content-center">
          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-12 align-items-center justify-content-center">
            <h1 class="d-block fw-bold mb-5 text-white">
              马上使用 FootyForecast
            </h1>
            <h3 class="fw-semibold mb-8 text-white">
              让您的竞猜之旅更便捷、高效、智能。
            </h3>
            <p>
              <span class="badge text-outline-danger me-10">高命中率</span>
              <span class="badge text-outline-info me-10">推送稳定</span>
              <span class="badge text-outline-warning me-10">战绩可查</span>
              <span class="badge text-outline-primary me-10">后续新功能免费</span>
            </p>
            <!-- <span class="fw-semibold  mt-lg-3 text-white me-20 mt-3">电脑版</span> -->
            <b-button variant="success" class="mt-lg-3" @click="dowmload">
              立即下载
            </b-button>

            <!-- <button
              class=" mt-20
              default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-11 bg-success"
              @click="dowmload">
              <feather-icon icon="DownloadIcon" size="20" />
              快速下载
            </button> -->
          </div>

          <div class="col-6 d-none d-lg-flex align-items-center p-5 ">
            <div class=" d-lg-flex align-items-center justify-content-center px-5 mt-10 ">
              <img class="animate3" src="@/assets/images/slider/ball1.png" width="50px" alt="img">
              <img src="@/assets/images/slider/h1-layer1.png" width="400px" alt="Slider Layer Image">
            </div>
          </div>


        </div>
      </div>
      <div style="border-top: 1px dashed white;margin: 10px 30;"></div>
      <div class="row align-items-center text-center ">
        <div class="col-xxl-12 col-lg-12 col-md-12 d-lg-flex align-items-center justify-content-center">
          <div class="col-6 d-none d-lg-flex align-items-center p-5">
            <div class=" d-lg-flex align-items-center justify-content-center px-5">
              <img src="@/assets/images/slider/h1-layer2.png" width="300px" alt="Slider Layer Image">
              <img class="animate3" src="@/assets/images/slider/ball2.png" width="40px" alt="img">
            </div>
          </div>

          <div class="col-xxl-6 col-lg-6 col-md-6 col-sm-12 align-items-center justify-content-center">
            <h1 class="d-block fw-bold mb-5 text-white">
              FootyForecast
            </h1>
            <h3 class="fw-semibold mb-8 text-white">
              手机也能看!
            </h3>
            <p>
              <span class="badge text-outline-danger me-10">无须下载</span>
              <span class="badge text-outline-info me-10">无需安装</span>
              <span class="badge text-outline-primary me-10">随时随地都可以看</span>
            </p>
            <span class="fw-semibold mb-8 text-white me-20">微信扫描</span>
            <img class="animate3" src="@/assets/images/h5_web_code.png" width="90px" alt="img">
          </div>


        </div>
      </div>
    </div>


  </div>
</template>

<script>
import NavHeader from './NavHeader.vue'
import request from '@/utils/request.js';

// import { Swiper, SwiperSlide } from "swiper/vue";
// import { Autoplay, Pagination } from "swiper/modules";


export default {
  name: "DownLoad",
  components: {
    NavHeader
    // Swiper,
    // SwiperSlide,
  },

  data() {
    return {
      // modules: [Autoplay, Pagination],
    };
  },

  methods: {
    dowmload() {
      let a = document.createElement('a')
      document.body.appendChild(a)
      a.href = '/FootyForecast/FootyForecast.msi'
      a.download = 'FootyForecast' + '.msi'
      a.style.display = 'none'
      a.click()
      document.body.removeChild(a);

      var post_url =
        '/AI/count?route=' + '下载软件！！！';
      let opts = {
        type: 1, //1为数据接口；2为静态资源请求
        url: post_url,
        method: 'get'
      };
      request.openHttpRequest(opts).then(res => { });
    },

  }
};
</script>
</script>

<style lang="scss"></style>
